import { Link } from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="container-wide">
        <div className="footer-grid">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: 'linear-gradient(135deg, var(--primary-500), var(--primary-400))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 800, fontSize: '0.9rem' }}>N</div>
              <div>
                <div style={{ fontWeight: 700, color: 'white', fontSize: '1.1rem' }}>NGADHU</div>
                <div style={{ fontSize: '0.65rem', color: 'var(--gray-500)', letterSpacing: '0.5px' }}>{t('footer.ngada_full')}</div>
              </div>
            </div>
            <p style={{ fontSize: '0.85rem', lineHeight: 1.7, marginBottom: '1rem', maxWidth: '320px' }}>
              {t('footer.desc')}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', fontSize: '0.85rem' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><FiMapPin size={14} /> Jl. Soekarno-Hatta, Bajawa, Ngada, NTT</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><FiPhone size={14} /> (0384) 21234</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><FiMail size={14} /> info@ngadhu.go.id</span>
            </div>
          </div>
          <div>
            <h4>{t('footer.navigation')}</h4>
            <ul className="footer-links">
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/dataset">{t('nav.dataset')}</Link></li>
              <li><Link to="/analitik">{t('nav.analitik')}</Link></li>
              <li><Link to="/berita">{t('nav.news')}</Link></li>
              <li><Link to="/profil">{t('nav.profile')}</Link></li>
            </ul>
          </div>
          <div>
            <h4>{t('footer.data_categories')}</h4>
            <ul className="footer-links">
              <li><Link to="/dataset?kategori=pendidikan">{t('categories.pendidikan')}</Link></li>
              <li><Link to="/dataset?kategori=kesehatan">{t('categories.kesehatan')}</Link></li>
              <li><Link to="/dataset?kategori=ekonomi">{t('categories.ekonomi')}</Link></li>
              <li><Link to="/dataset?kategori=pertanian">{t('categories.pertanian')}</Link></li>
              <li><Link to="/dataset?kategori=pariwisata">{t('categories.pariwisata')}</Link></li>
              <li><Link to="/dataset?kategori=infrastruktur">{t('categories.infrastruktur')}</Link></li>
            </ul>
          </div>
          <div>
            <h4>{t('footer.links')}</h4>
            <ul className="footer-links">
              <li><a href="https://ngadakab.go.id" target="_blank" rel="noreferrer">Pemkab Ngada</a></li>
              <li><a href="https://nttprov.go.id" target="_blank" rel="noreferrer">Pemprov NTT</a></li>
              <li><a href="https://data.go.id" target="_blank" rel="noreferrer">Satu Data Indonesia</a></li>
              <li><a href="https://bps.go.id" target="_blank" rel="noreferrer">BPS Pusat</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>&copy; {new Date().getFullYear()} NGADHU - {t('footer.copyright')}</span>
          <span>{t('footer.made_with')}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
